(function () {
  const SELECTOR = 'a[href="#tidio"]';

  let chatAvailable = false;

  function getTriggers() {
    return document.querySelectorAll(SELECTOR);
  }

  function setAvailable(available) {
    chatAvailable = available;
    getTriggers().forEach((trigger) => {
      trigger.classList.toggle('disabled', !available);
      if (available) {
        trigger.removeAttribute('aria-disabled');
        trigger.removeAttribute('tabindex');
      } else {
        trigger.setAttribute('aria-disabled', 'true');
        trigger.setAttribute('tabindex', '-1');
      }
    });
  }

  function onTidioReady() {
    if (!window.tidioChatApi) return;
    setAvailable(true);
    window.tidioChatApi.on('setStatus', (status) => setAvailable(status === 'online'));
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(SELECTOR);
    if (!trigger) return;
    event.preventDefault();
    if (!chatAvailable || !window.tidioChatApi) return;
    window.tidioChatApi.show();
    window.tidioChatApi.open();
  });

  function init() {
    setAvailable(false);

    if (window.tidioChatApi) {
      onTidioReady();
    } else {
      // Buttons stay disabled if Tidio never loads (blocked, removed, etc.)
      document.addEventListener('tidioChat-ready', onTidioReady, { once: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
